import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BookingConflictsDialogComponent } from '../../dialogs/booking-conflicts-dialog/booking-conflicts-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-conflict-count',
    templateUrl: './conflict-count.component.html',
    standalone: true,
    imports: [NgIf, MatIcon, MatTooltip]
})
export class ConflictCountComponent {
  @Input() set count(value: number | null) {
    if (this.currenctCount === 0 && value > 0) {
      this.toastr.warning('This item now has conflicts', 'Warning');
    }
    if (this.currenctCount > 0 && value === 0) {
      this.toastr.success('This item no longer has conflicts');
    }
    this.currenctCount = value;
  }

  @Input() hireItemId: number;

  currenctCount = null;

  constructor(private toastr: ToastrService, private dialog: MatDialog) {}

  showConflictsDialog() {
    this.dialog.open(BookingConflictsDialogComponent, {
      data: { id: this.hireItemId, type: 'hireItem' }
    });
  }
}
